var _rect, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadSpinnerWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 1,
    y: 1,
    fill: "#ffc001",
    rx: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle20",
    fill: "freeze",
    attributeName: "x",
    begin: "0;svgSpinnersBlocksShuffle27.end",
    dur: "0.2s",
    values: "1;13"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle21",
    fill: "freeze",
    attributeName: "y",
    begin: "svgSpinnersBlocksShuffle24.end",
    dur: "0.2s",
    values: "1;13"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle22",
    fill: "freeze",
    attributeName: "x",
    begin: "svgSpinnersBlocksShuffle25.end",
    dur: "0.2s",
    values: "13;1"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle23",
    fill: "freeze",
    attributeName: "y",
    begin: "svgSpinnersBlocksShuffle26.end",
    dur: "0.2s",
    values: "13;1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 1,
    y: 13,
    fill: "#ff4d00",
    rx: 3
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle24",
    fill: "freeze",
    attributeName: "y",
    begin: "svgSpinnersBlocksShuffle20.end",
    dur: "0.2s",
    values: "13;1"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle25",
    fill: "freeze",
    attributeName: "x",
    begin: "svgSpinnersBlocksShuffle21.end",
    dur: "0.2s",
    values: "1;13"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle26",
    fill: "freeze",
    attributeName: "y",
    begin: "svgSpinnersBlocksShuffle22.end",
    dur: "0.2s",
    values: "1;13"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBlocksShuffle27",
    fill: "freeze",
    attributeName: "x",
    begin: "svgSpinnersBlocksShuffle23.end",
    dur: "0.2s",
    values: "13;1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSpinnerWhite);
export default __webpack_public_path__ + "static/media/downloadSpinner-white.c27cf0113cc771f5f5c85c2d5e18f6e7.svg";
export { ForwardRef as ReactComponent };